import {useForm} from 'react-hook-form';
import { useEffect, useState } from 'react';
import { ProgressCircle } from '@common/ui/progress/progress-circle';
import { CrupdateLoanProgramForm } from './crupdate-loan-program-form';
import { queryClient } from '@common/http/query-client';
import { useLoanPrograms } from './requests/use-loan-programs';
import { CrupdateLoanProgramLayout } from './crupdate-loan-program-layout';

export function CreateLoanProgramPage({loanProduct}: any) {

  const [status, setStatus] = useState('');
  const [metaHeader, setMetaHeader] = useState('');
  const [totalFiles, setTotalFiles] = useState(0);
  const id = loanProduct.id;

  const {data: uw_data} = useLoanPrograms(id);

  window.Echo.channel('loan-program').listen('.process', (e: any) => {
    if (id && e.data[id] != undefined) {
      const item = e.data[id];
      if (item.status) {
        setStatus(item.status);
      }

      if (item.total_files) {
        setTotalFiles(item.total_files);
      }

      if (item.meta_header) {
        setMetaHeader(item.meta_header);
      }
    }
  });

  useEffect(() => {
    if (id || status) {
      queryClient.invalidateQueries({
        queryKey: [`loan-products/${id}/loan-programs`],
      });
    }
  }, [id, metaHeader, status, totalFiles]);


  if (uw_data) {
    return (
      <>
      <LoanProgramUploading loan_product={loanProduct} loan_program_items={uw_data.loan_programs}/>
      </>
    );
  } else {
    return (<ProgressCircle isIndeterminate aria-label="Loading data..." />);
  }
}


export interface LoanProgramWithValues {
}

export function LoanProgramUploading({loan_product, loan_program_items}:{loan_product: string, loan_program_items: any}) {

  const [defaultValues, setDefaultValues] = useState<any>({});
  
  const form = useForm<LoanProgramWithValues>({
    defaultValues: defaultValues,
  });

  useEffect(() => {
    if (loan_program_items) {
      const newDefaultValues: { [key: string]: string } = {};
      loan_program_items.forEach((item: any, pindex: number) => {
        newDefaultValues[`${item.id}_meta_header`] = item.meta_header;
      });
      // Update state and reset form with new values
      setDefaultValues(newDefaultValues);
      form.reset(newDefaultValues); // Reset form with updated values
    }
  }, [loan_program_items, form]);

  return (
    <CrupdateLoanProgramLayout
      form={form}
    >
      <CrupdateLoanProgramForm loan_product={loan_product} loan_program_items={loan_program_items}/>
    </CrupdateLoanProgramLayout>
  );
  
}


  
